import type { Validators } from '@quickbit/qb-design-system';
import { KybFormData } from '../types';

/**
 * Validates a Legal Entity Identifier (LEI) based on ISO 17442.
 * Completely generated by ChatGPT so it takes the blame if it's wrong.
 *
 * @param lei The LEI string to validate.
 * @returns True if the LEI is valid, false otherwise.
 */

export const kybValidators: Validators<KybFormData, KybFormData> = {
  fullCompanyName: (name: string) =>
    !name || name.trim().length < 1 ? 'Can not be empty.' : undefined,
  registrationNumber: (number: string, currentValues: KybFormData) => {
    if (currentValues.incorporationCountry === 'SE') {
      return !/[\d]{6}-[\d]{4}/.test(number)
        ? 'Needs to be on the format XXXXXX-XXXX.'
        : undefined;
    }
    return number.length < 1 ? 'Can not be empty.' : undefined;
  },
  incorporationCountry: (country: string | undefined) =>
    !country ? 'This needs to be set.' : undefined,
  expectedMonthlyVolume: (volume: number) =>
    Number(volume) === 0 ? 'Can not be empty.' : undefined,
  expectedMonthlyTransactions: (pay: number) =>
    Number(pay) === 0 ? 'Can not be empty.' : undefined,
  turnover: (turnover: number) =>
    Number(turnover) === 0 ? 'Can not be empty.' : undefined,
  jurisdictions: {
    value: (value: string) =>
      !value || value.trim().length < 1 ? 'Can not be empty.' : undefined,
  },
  relatedPeople: {
    firstName: (firstName: string) =>
      !firstName || firstName.trim().length < 1
        ? 'Can not be empty.'
        : undefined,
    lastName: (lastName: string) =>
      !lastName || lastName.trim().length < 1 ? 'Can not be empty.' : undefined,
    ssn: (ssn: string) =>
      !ssn || ssn.trim().length < 1 ? 'Can not be empty.' : undefined,
    dateOfBirth: (date: Date | null) => {
      if (date === null) return 'Needs to be set.';
      if (date > new Date()) return 'Cannot be in the future.';
      return undefined;
    },
    type: (type: string | undefined) =>
      !type ? 'This needs to be set.' : undefined,
    placeOfBirth: (placeOfBirth: string) =>
      placeOfBirth.length > 100
        ? 'Can not be longer than 100 characters.'
        : undefined,
  },
};
